import config from "../config.json";

let acquirePromise = null;

export async function acquireAccessToken(msalInstance, account) {
  if (!msalInstance || !account) return null;

  if (!acquirePromise) {
    acquirePromise = msalInstance
      .acquireTokenSilent({
        account,
        scopes: [
          `https://${config.AUTH.ADB2C_TENANT_NAME}.onmicrosoft.com/core-api/core-api.access`,
        ],
      })
      .then(r => r.accessToken)
      .finally(() => {
        acquirePromise = null;
      });
  }

  return acquirePromise;
}
